export const enum RoutePath {
  Home = "/",
  About = "/about",
  Blog = "/blog",
  BlogPost = "/blog/:slug",
  Connect = "/connect",
  Experience = "/experience",
  ExperienceInfo = "/experience/info",
  PrivacyPolicy = "/privacy",
  Process = "/process",
  Disclaimer = "/disclaimer",
}
